import { render, staticRenderFns } from "./ConfigureEntityField.vue?vue&type=template&id=12d9b149&scoped=true"
import script from "./ConfigureEntityField.vue?vue&type=script&lang=js"
export * from "./ConfigureEntityField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureEntityField.vue?vue&type=style&index=0&id=12d9b149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9b149",
  null
  
)

export default component.exports